import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full p-6" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "flex justify-between items-center mb-2" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_6 = { class: "text-xl font-bold" }
const _hoisted_7 = { class: "text-gray-600 mb-2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_10 = { class: "w-full bg-gray-200 rounded-full h-2.5" }
const _hoisted_11 = {
  key: 1,
  class: "bg-gray-50 rounded-lg p-6 text-center border border-gray-200"
}
const _hoisted_12 = { class: "flex flex-col items-center" }
const _hoisted_13 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-6" }
const _hoisted_14 = { class: "lg:col-span-2" }
const _hoisted_15 = { class: "bg-white rounded-lg shadow-md overflow-hidden" }
const _hoisted_16 = { class: "border-b border-gray-200" }
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = { class: "overflow-x-auto" }
const _hoisted_19 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_20 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_21 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_22 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_23 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_24 = { class: "text-sm text-gray-500" }
const _hoisted_25 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_26 = { class: "text-sm text-gray-500" }
const _hoisted_27 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_28 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_29 = { class: "px-6 py-4 whitespace-nowrap text-right text-sm font-medium" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 0,
  class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50"
}
const _hoisted_34 = { class: "bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative" }
const _hoisted_35 = { class: "mb-4" }
const _hoisted_36 = { class: "mb-6" }
const _hoisted_37 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_38 = { class: "flex justify-end space-x-3" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  key: 1,
  class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50"
}
const _hoisted_43 = { class: "bg-white rounded-lg shadow-lg w-full max-w-md p-6" }
const _hoisted_44 = { class: "flex justify-end space-x-3" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_47 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[13] || (_cache[13] = _createElementVNode("h1", { class: "text-2xl font-bold text-primary" }, "Dashboard", -1)),
          _createElementVNode("div", null, [
            (_ctx.canTriggerForecast)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openNewForecastModal && _ctx.openNewForecastModal(...args))),
                  class: "bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/90 transition-colors"
                }, _cache[12] || (_cache[12] = [
                  _createElementVNode("svg", {
                    class: "h-5 w-5 mr-2 inline",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                    })
                  ], -1),
                  _createTextVNode(" New Forecast ")
                ])))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-muted-foreground" }, "Overview of tasks, activities, and recent updates", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.forecastingProcesses.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forecastingProcesses, (process) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: process.id,
                  class: "bg-white rounded-lg shadow-md p-6"
                }, [
                  _createElementVNode("h2", _hoisted_6, _toDisplayString(process.name) + " Reporting Period", 1),
                  _createElementVNode("p", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(process.start_date)) + " - " + _toDisplayString(_ctx.formatDate(process.end_date)) + " ", 1),
                    (_ctx.getDaysRemaining(process.end_date) > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(_ctx.getDaysRemaining(process.end_date)) + " days remaining) ", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, " (Overdue) "))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: "bg-blue-600 h-2.5 rounded-full",
                      style: _normalizeStyle({ width: _ctx.getProgressPercentage(process.start_date, process.end_date) + '%' })
                    }, null, 4)
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"mb-4 p-3 bg-gray-100 rounded-full\"><svg class=\"h-8 w-8 text-gray-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z\"></path></svg></div><h3 class=\"text-lg font-medium text-gray-900 mb-2\">No Active Reporting Periods</h3><p class=\"text-gray-500 mb-6\">Start a new forecast process to begin tracking reporting periods</p>", 3)),
                (_ctx.canTriggerForecast)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openNewForecastModal && _ctx.openNewForecastModal(...args))),
                      class: "inline-flex items-center px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors"
                    }, _cache[15] || (_cache[15] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5 mr-2",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                        })
                      ], -1),
                      _createTextVNode(" Start New Forecast ")
                    ])))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[21] || (_cache[21] = _createStaticVNode("<div class=\"p-4 border-b border-gray-200 flex justify-between items-center\"><div><h2 class=\"text-xl font-semibold\">Tasks</h2><p class=\"text-sm text-gray-500\">Manage and track reporting tasks</p></div><button class=\"p-2 rounded-md hover:bg-gray-100\"><svg class=\"h-5 w-5 text-gray-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M19 9l-7 7-7-7\"></path></svg></button></div>", 1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'my-tasks')),
                  class: _normalizeClass(["px-4 py-2 border-b-2 font-medium transition-colors duration-200", _ctx.activeTab === 'my-tasks' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700'])
                }, " My Tasks ", 2),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'all-tasks')),
                  class: _normalizeClass(["px-4 py-2 border-b-2 font-medium transition-colors duration-200", _ctx.activeTab === 'all-tasks' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700'])
                }, " All Tasks ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("table", _hoisted_19, [
                _cache[20] || (_cache[20] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      scope: "col",
                      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    }, "Report"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    }, "Planner"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    }, "Last Modified"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    }, "Due Date"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    }, "State"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "relative px-6 py-3"
                    }, [
                      _createElementVNode("span", { class: "sr-only" }, "Actions")
                    ])
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeTab === 'my-tasks' ? _ctx.myTasks : _ctx.allTasks, (task) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: task.id
                    }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, _toDisplayString(task.report), 1)
                        ]),
                        _createElementVNode("td", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, _toDisplayString(task.planner), 1)
                        ]),
                        _createElementVNode("td", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(task.lastModified), 1)
                        ]),
                        _createElementVNode("td", _hoisted_27, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["text-sm", task.dueDateClass])
                          }, _toDisplayString(task.dueDate), 3)
                        ]),
                        _createElementVNode("td", _hoisted_28, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["px-2 inline-flex text-xs leading-5 font-semibold rounded-full", task.stateClass])
                          }, _toDisplayString(task.state), 3)
                        ]),
                        _createElementVNode("td", _hoisted_29, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.toggleTaskExpanded(task.id)),
                            class: _normalizeClass(["text-primary hover:text-primary-dark transition-transform duration-200", { 'transform rotate-180': _ctx.expandedTaskId === task.id }])
                          }, _cache[17] || (_cache[17] = [
                            _createElementVNode("svg", {
                              class: "h-5 w-5",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 9l-7 7-7-7"
                              })
                            ], -1)
                          ]), 10, _hoisted_30)
                        ])
                      ]),
                      (_ctx.expandedTaskId === task.id)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_31, _cache[18] || (_cache[18] = [
                            _createElementVNode("td", {
                              colspan: "6",
                              class: "px-6 py-4 bg-gray-50 border-t border-gray-200"
                            }, [
                              _createElementVNode("div", { class: "flex space-x-3" }, [
                                _createElementVNode("button", { class: "inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary" }, [
                                  _createElementVNode("svg", {
                                    class: "h-4 w-4 mr-1",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M5 13l4 4L19 7"
                                    })
                                  ]),
                                  _createTextVNode(" Approve ")
                                ]),
                                _createElementVNode("button", { class: "inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary" }, [
                                  _createElementVNode("svg", {
                                    class: "h-4 w-4 mr-1",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                    })
                                  ]),
                                  _createTextVNode(" Request Changes ")
                                ]),
                                _createElementVNode("button", { class: "inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary" }, [
                                  _createElementVNode("svg", {
                                    class: "h-4 w-4 mr-1",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                                    })
                                  ]),
                                  _createTextVNode(" Add Comment ")
                                ])
                              ])
                            ], -1)
                          ])))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  ((_ctx.activeTab === 'my-tasks' && _ctx.myTasks.length === 0) || (_ctx.activeTab === 'all-tasks' && _ctx.allTasks.length === 0))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_32, _cache[19] || (_cache[19] = [
                        _createElementVNode("td", {
                          colspan: "6",
                          class: "px-6 py-10 text-center"
                        }, [
                          _createElementVNode("p", { class: "text-gray-500" }, "No tasks available")
                        ], -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"lg:col-span-1\"><div class=\"bg-white rounded-lg shadow-md overflow-hidden\"><div class=\"p-4 border-b border-gray-200 flex justify-between items-center\"><div><h2 class=\"text-xl font-semibold\">Activity Feed</h2><p class=\"text-sm text-gray-500\">Recent actions by team members</p></div></div><div class=\"p-4\"><ul class=\"space-y-4\"><li class=\"flex items-start\"><div class=\"flex-shrink-0 mr-3\"><div class=\"h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-500 font-semibold\"> L </div></div><div><p class=\"text-sm\"><span class=\"font-medium\">Luka Novak</span><span class=\"text-gray-500\"> uploaded </span><span class=\"font-medium\">Quarterly Forecast Report 1</span></p><p class=\"text-xs text-gray-500 mt-1\"><svg class=\"inline-block h-3 w-3 mr-1\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg> 10 minutes ago </p></div></li><li class=\"flex items-start\"><div class=\"flex-shrink-0 mr-3\"><div class=\"h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-500 font-semibold\"> M </div></div><div><p class=\"text-sm\"><span class=\"font-medium\">Maja Kovač</span><span class=\"text-gray-500\"> downloaded </span><span class=\"font-medium\">Q2 2025 Template</span></p><p class=\"text-xs text-gray-500 mt-1\"><svg class=\"inline-block h-3 w-3 mr-1\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg> 25 minutes ago </p></div></li><li class=\"flex items-start\"><div class=\"flex-shrink-0 mr-3\"><div class=\"h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-500 font-semibold\"> J </div></div><div><p class=\"text-sm\"><span class=\"font-medium\">Janez Horvat</span><span class=\"text-gray-500\"> approved </span><span class=\"font-medium\">Nina&#39;s Q1 Report</span></p><p class=\"text-xs text-gray-500 mt-1\"><svg class=\"inline-block h-3 w-3 mr-1\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg> 1 hour ago </p></div></li><li class=\"flex items-start\"><div class=\"flex-shrink-0 mr-3\"><div class=\"h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-500 font-semibold\"> N </div></div><div><p class=\"text-sm\"><span class=\"font-medium\">Nina Zupančič</span><span class=\"text-gray-500\"> rejected </span><span class=\"font-medium\">Janez&#39;s Q2 Forecast</span></p><p class=\"text-xs text-gray-500 mt-1\"><svg class=\"inline-block h-3 w-3 mr-1\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg> 2 hours ago </p></div></li><li class=\"flex items-start\"><div class=\"flex-shrink-0 mr-3\"><div class=\"h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-500 font-semibold\"> M </div></div><div><p class=\"text-sm\"><span class=\"font-medium\">Matej Krajnc</span><span class=\"text-gray-500\"> commented on </span><span class=\"font-medium\">Q1 2025 Summary</span></p><p class=\"text-xs text-gray-500 mt-1\"><svg class=\"inline-block h-3 w-3 mr-1\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg> 3 hours ago </p></div></li><li class=\"flex items-start\"><div class=\"flex-shrink-0 mr-3\"><div class=\"h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-500 font-semibold\"> A </div></div><div><p class=\"text-sm\"><span class=\"font-medium\">Ana Vidmar</span><span class=\"text-gray-500\"> flagged </span><span class=\"font-medium\">inconsistency in Q3 data</span></p><p class=\"text-xs text-gray-500 mt-1\"><svg class=\"inline-block h-3 w-3 mr-1\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg> 5 hours ago </p></div></li></ul></div></div></div>", 1))
      ])
    ]),
    (_ctx.showForecastModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showForecastModal = false)),
              class: "absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            }, _cache[23] || (_cache[23] = [
              _createElementVNode("span", { class: "text-xl" }, "×", -1)
            ])),
            _cache[29] || (_cache[29] = _createElementVNode("h2", { class: "text-xl font-bold mb-2" }, "Create New Reporting Period", -1)),
            _cache[30] || (_cache[30] = _createElementVNode("p", { class: "text-gray-600 mb-6" }, "Set up a new reporting period by providing a name and date range.", -1)),
            _createElementVNode("div", _hoisted_35, [
              _cache[24] || (_cache[24] = _createElementVNode("label", {
                for: "periodName",
                class: "block text-sm font-medium text-gray-700 mb-1"
              }, "Period Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "periodName",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.periodName) = $event)),
                placeholder: "e.g. Q3 2025",
                class: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              }, null, 512), [
                [_vModelText, _ctx.periodName]
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Date Range", -1)),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", null, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", {
                    for: "startDate",
                    class: "block text-sm text-gray-700 mb-1"
                  }, "Start Date", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "startDate",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.startDate) = $event)),
                    class: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  }, null, 512), [
                    [_vModelText, _ctx.startDate]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", {
                    for: "endDate",
                    class: "block text-sm text-gray-700 mb-1"
                  }, "End Date", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "endDate",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.endDate) = $event)),
                    class: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  }, null, 512), [
                    [_vModelText, _ctx.endDate]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showForecastModal = false)),
                class: "px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.confirmCreateForecast && _ctx.confirmCreateForecast(...args))),
                class: "px-4 py-2 bg-blue-700 text-white rounded-md hover:bg-blue-800 transition-colors",
                disabled: _ctx.isLoading
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, _cache[28] || (_cache[28] = [
                      _createElementVNode("svg", {
                        class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                      ], -1),
                      _createTextVNode(" Processing... ")
                    ])))
                  : (_openBlock(), _createElementBlock("span", _hoisted_41, "Create Period"))
              ], 8, _hoisted_39)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _cache[32] || (_cache[32] = _createElementVNode("h3", { class: "text-lg font-medium mb-3" }, "Confirm Forecast Creation", -1)),
            _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-gray-600 mb-6" }, "Are you sure you want to create a new forecasting process? This action cannot be undone.", -1)),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showConfirmDialog = false)),
                class: "px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.startForecastProcess && _ctx.startForecastProcess(...args))),
                class: "px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors",
                disabled: _ctx.isLoading
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_46, _cache[31] || (_cache[31] = [
                      _createElementVNode("svg", {
                        class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                      ], -1),
                      _createTextVNode(" Processing... ")
                    ])))
                  : (_openBlock(), _createElementBlock("span", _hoisted_47, "Yes, Create"))
              ], 8, _hoisted_45)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}